import {useEffect, useId, useRef} from "react";
import {createPortal} from "react-dom";
import {X} from "lucide-react";
import {useTranslation} from "../../../shared/i18n";


export const DialogShell = ({open, title, entity, pending = false, onClose, children}) => {
    const {t} = useTranslation();
    const titleId = useId();
    const dialogRef = useRef(null);

    useEffect(() => {
        if (!open) return undefined;
        const frame = window.requestAnimationFrame(() => dialogRef.current?.focus());
        return () => window.cancelAnimationFrame(frame);
    }, [open]);

    useEffect(() => {
        if (!open) return undefined;
        const onKeyDown = (event) => {
            if (event.key === "Escape" && !pending) onClose();
        };
        document.addEventListener("keydown", onKeyDown);
        return () => document.removeEventListener("keydown", onKeyDown);
    }, [onClose, open, pending]);

    if (!open) return null;

    return createPortal(
        <div className="deployer-dialog-backdrop" onMouseDown={(event) => {
            if (event.target === event.currentTarget && !pending) onClose();
        }}>
            <section ref={dialogRef} className="deployer-dialog" role="dialog" aria-modal="true" aria-labelledby={titleId} aria-busy={pending} tabIndex={-1}>
                <header className="deployer-dialog-header">
                    <div>
                        {entity ? <p>{entity}</p> : null}
                        <h2 id={titleId}>{title}</h2>
                    </div>
                    <button type="button" className="admin-icon-button" aria-label={t("sections.deployers.p64")} title={t("sections.deployers.p63")} disabled={pending} onClick={onClose}>
                        <X size={18} />
                    </button>
                </header>
                {children}
            </section>
        </div>,
        document.body,
    );
};
